import { useQuery } from '@tanstack/react-query';
import { useEventStatsBatch } from '@/hooks/useEventStatsBatch';
import type { EventStats } from '@/lib/ditto';

/**
 * Ditto precomputed engagement stats (NIP-85 kind 30383) for an event.
 * `data` is `null` when Ditto has no assertion for the event, in which case
 * callers should fall back to client-side counting.
 */
export function useEventStats(eventId: string | undefined) {
  const { load } = useEventStatsBatch();

  return useQuery<EventStats | null>({
    queryKey: ['nostr', 'event-stats', eventId ?? ''],
    queryFn: () => load(eventId!),
    enabled: !!eventId,
    staleTime: 60 * 1000,
  });
}
